import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.78096 1.44613C5.98568 1.32944 6.08115 1.08565 6.01009 0.860975C5.93904 0.636298 5.72076 0.491727 5.48617 0.51397C2.69465 0.77865 0.51123 3.12865 0.51123 5.9892C0.51123 9.02676 2.97366 11.4892 6.01123 11.4892C8.87163 11.4892 11.2215 9.30601 11.4864 6.5147C11.5087 6.28011 11.3641 6.06182 11.1395 5.99075C10.9148 5.91968 10.671 6.01512 10.5543 6.21984C9.95114 7.27783 8.81396 7.98932 7.51123 7.98932C5.57823 7.98932 4.01123 6.42231 4.01123 4.48932C4.01123 3.18649 4.72283 2.04923 5.78096 1.44613Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.70794 1.92752C7.98091 1.77194 8.1082 1.44689 8.01346 1.14732C7.91872 0.847746 7.62768 0.654984 7.31489 0.684642C3.59286 1.03755 0.681641 4.17088 0.681641 7.98495C0.681641 12.035 3.96489 15.3183 8.01497 15.3183C11.8288 15.3183 14.962 12.4074 15.3152 8.68561C15.3449 8.37283 15.1522 8.08177 14.8526 7.98701C14.553 7.89225 14.228 8.01951 14.0724 8.29246C13.2682 9.70312 11.7519 10.6518 10.015 10.6518C7.43764 10.6518 5.34831 8.56244 5.34831 5.98511C5.34831 4.248 6.29711 2.73166 7.70794 1.92752Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.63493 2.40989C9.97614 2.21541 10.1352 1.80909 10.0168 1.43463C9.8984 1.06017 9.5346 0.819219 9.14361 0.85629C4.49108 1.29742 0.852051 5.21408 0.852051 9.98167C0.852051 15.0443 4.95611 19.1483 10.0187 19.1483C14.7861 19.1483 18.7026 15.5097 19.144 10.8575C19.1811 10.4665 18.9402 10.1027 18.5658 9.98425C18.1913 9.8658 17.785 10.0249 17.5905 10.3661C16.5852 12.1294 14.6899 13.3152 12.5187 13.3152C9.29706 13.3152 6.68538 10.7035 6.68538 7.48187C6.68538 5.31049 7.87139 3.41507 9.63493 2.40989Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_16145)">
        <path d="M3.01123 4.4883C3.01124 3.62995 3.25215 2.82824 3.66895 2.14601C2.37527 2.93644 1.51123 4.36134 1.51123 5.9883C1.51127 8.47354 3.52597 10.4883 6.01123 10.4883C7.638 10.4883 9.06205 9.62401 9.85254 8.33058C9.17046 8.74712 8.36929 8.9883 7.51123 8.9883C5.02595 8.9883 3.01123 6.97358 3.01123 4.4883ZM4.01123 4.4883C4.01123 6.42129 5.57823 7.9883 7.51123 7.9883C8.81396 7.9883 9.95106 7.27676 10.5542 6.21877C10.6709 6.01407 10.915 5.91869 11.1396 5.98976C11.3642 6.06089 11.5086 6.27917 11.4863 6.51369C11.2214 9.305 8.87163 11.4883 6.01123 11.4883C2.97369 11.4883 0.511273 9.02583 0.51123 5.9883C0.51123 3.12774 2.69481 0.777879 5.48633 0.513199L5.52979 0.510757C5.74736 0.509072 5.94361 0.64923 6.01025 0.859878C6.08131 1.08456 5.98549 1.32864 5.78076 1.44533C4.72277 2.04846 4.01125 3.18558 4.01123 4.4883Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_16145">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_16143)">
        <path d="M4.01522 5.98505C4.01523 4.84059 4.33644 3.77163 4.89217 2.862C3.16727 3.91591 2.01522 5.81577 2.01522 7.98505C2.01527 11.2987 4.70154 13.985 8.01522 13.985C10.1842 13.985 12.083 12.8327 13.137 11.1081C12.2275 11.6635 11.1593 11.985 10.0152 11.985C6.70151 11.985 4.01522 9.29875 4.01522 5.98505ZM5.34855 5.98505C5.34855 8.56237 7.43789 10.6517 10.0152 10.6517C11.7522 10.6517 13.2683 9.70299 14.0725 8.29234C14.2281 8.01942 14.5536 7.89224 14.8531 7.987C15.1525 8.08183 15.345 8.37287 15.3153 8.68557C14.9622 12.4073 11.8291 15.3184 8.01522 15.3184C3.96516 15.3184 0.681941 12.0351 0.681885 7.98505C0.681885 4.17098 3.59332 1.03782 7.31535 0.684916L7.37329 0.681661C7.66339 0.679413 7.92506 0.866291 8.01392 1.14716C8.10865 1.44672 7.98089 1.77217 7.70793 1.92775C6.29727 2.73193 5.34857 4.24808 5.34855 5.98505Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_16143">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_16141)">
        <path d="M5.01896 7.48082C5.01897 6.05025 5.42049 4.71405 6.11515 3.57701C3.95902 4.8944 2.51896 7.26922 2.51896 9.98082C2.51903 14.1229 5.87687 17.4808 10.019 17.4808C12.7302 17.4808 15.1037 16.0403 16.4211 13.8846C15.2843 14.5789 13.9491 14.9808 12.519 14.9808C8.37683 14.9808 5.01896 11.623 5.01896 7.48082ZM6.68563 7.48082C6.68563 10.7025 9.2973 13.3142 12.519 13.3142C14.6902 13.3142 16.5853 12.1283 17.5906 10.3649C17.7851 10.0238 18.1919 9.86482 18.5663 9.98326C18.9406 10.1018 19.1812 10.4656 19.1441 10.8565C18.7027 15.5087 14.7863 19.1475 10.019 19.1475C4.95639 19.1475 0.852365 15.0434 0.852295 9.98082C0.852295 5.21323 4.49159 1.29679 9.14412 0.855657L9.21655 0.851588C9.57918 0.848778 9.90626 1.08238 10.0173 1.43346C10.1358 1.80792 9.97606 2.21473 9.63485 2.4092C7.87153 3.41442 6.68565 5.30962 6.68563 7.48082Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_16141">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconMoon02: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"moon-02"} {...props} />
);
